import { ReactElement } from 'react';
import SweetPotatoCasseroleJPG from 'consumer/pages/recipes/ThanksgivingLTO/SweetPotatoCasserole.jpg';
import SavoryStuffingJPG from 'consumer/pages/recipes/ThanksgivingLTO/SavoryStuffing.jpg';
import GREENBEANCASSEROLEJPG from 'consumer/pages/recipes/ThanksgivingLTO/GreenBeanCasserole.jpg';
import SweetPotatoCasseroleWEBP from 'consumer/pages/recipes/ThanksgivingLTO/SweetPotatoCasserole.webp';
import SavoryStuffingWEBP from 'consumer/pages/recipes/ThanksgivingLTO/SavoryStuffing.webp';
import GREENBEANCASSEROLEWEBP from 'consumer/pages/recipes/ThanksgivingLTO/GreenBeanCasserole.webp';
import { Component as PlusIcon } from 'icons/icon-ui--white-plus.svg';
import { Component as CirclePlusIcon } from 'icons/icon-circle-plus.svg';
import { Component as CircleMinusIcon } from 'icons/icon-circle-minus.svg';
import { useCart } from '../../../contexts/Cart';
import useSaveCart from '../../../hooks/useSaveCart';
import CartItem from '../../../models/CartItem';
import { toCurrency } from '../../../utils/numbers';

function ThanksgivingLTOCarousel(): ReactElement {
  const { cart, dispatch } = useCart();
  const { id: cartId } = cart;
  const saveCart = useSaveCart();

  const setQuantity = (qty:number, skuId:number) => {
    dispatch({
      type: 'setMenuItemQuantity',
      quantity: qty,
      skuId,
    });
    saveCart();
  };

  const ltoAddOnTitles = [
    'Sweet Potato Casserole',
    'Savory Stuffing',
    'Green Bean Casserole',
  ];

  const imageMap = {
    [ltoAddOnTitles[0]]: {
      jpg: SweetPotatoCasseroleJPG,
      webp: SweetPotatoCasseroleWEBP,
      backgroundColor: '#DFC2A4',
    },
    [ltoAddOnTitles[1]]: {
      jpg: SavoryStuffingJPG,
      webp: SavoryStuffingWEBP,
      backgroundColor: '#D9DDA9',
    },
    [ltoAddOnTitles[2]]: {
      jpg: GREENBEANCASSEROLEJPG,
      webp: GREENBEANCASSEROLEWEBP,
      backgroundColor: '#D6F2F9',
    },
  };

  const ltoAddOns:CartItem[] = cart?.menu_items.filter(
    (item) => item.sku?.is_lto_recommended_addon && ltoAddOnTitles.includes(item.sku?.title),
  );

  return (
    <div className="c-meal-management-recipes-LTO__carousel">
      <div className="c-meal-management-recipes-LTO_slider__container">
        {ltoAddOns
          .map((item) => {
            const { isSoldOut, sku, quantity, max_quantity: maxQuantity } = item;
            const {
              title, price, product_id: productId,
              link_to_product: linkToProduct, id: skuId,
            } = sku;
            return (
              <div
                className="c-meal-management-recipes-LTO_slider__slide"
                key={productId}
                style={{ backgroundColor: imageMap[title]?.backgroundColor }}
              >
                {quantity > 0 ? (
                  <div className="c-meal-management-recipes-LTO_slider__position
                  c-meal-management-recipes-LTO_slider__quantity-picker"
                  >
                    <CircleMinusIcon onClick={() => {
                      setQuantity(quantity - 1, skuId);
                    }}
                    />
                    {quantity}
                    <CirclePlusIcon onClick={() => {
                      const newQuantity = quantity + 1;
                      if (newQuantity <= maxQuantity) {
                        setQuantity(newQuantity, skuId);
                      }
                    }}
                    />
                  </div>
                ) : (
                  <button
                    id={`add-product${productId}-button`}
                    name="button"
                    type="button"
                    className="c-meal-management-recipes-LTO_slider__button
                    c-meal-management-recipes-LTO_slider__position"
                    onClick={() => {
                      setQuantity(1, skuId);
                    }}
                    disabled={isSoldOut}
                  >
                    {isSoldOut ? (
                      <>Sold Out</>
                    ) : (
                      <>
                        <PlusIcon />
                        Add
                      </>
                    )}
                  </button>
                )}
                <a
                  href={`${linkToProduct}?cart_id=${cartId}`}
                  className="c-meal-management-recipes-LTO_slider__clickable"
                >
                  <picture>
                    <source srcSet={imageMap[title]?.webp} type="image/webp" />
                    <img
                      className="c-meal-management-recipes-LTO_slider__img"
                      src={imageMap[title]?.jpg}
                      alt={title}
                      width="320"
                      height="320"
                    />
                  </picture>
                  <div>{title}</div>
                </a>
                <div className="c-meal-management-recipes-LTO_slider__price">
                  {toCurrency(price)}
                  {' '}
                  / each
                </div>
              </div>
            );
          })}
      </div>
    </div>

  );
}

export default ThanksgivingLTOCarousel;
